import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUser, isAuthenticated, isDeviceEnrolled } from '../utils';
import { getRoleHomePath } from './roleHome';

/**
 * Guards the enrollment screen. A terminal that is already enrolled **and** has
 * a live user session has nothing to enroll — bounce it to that user's role home.
 * Otherwise the screen renders: a fresh terminal enrolls here, and an
 * enrolled-but-locked terminal can re-enroll from here too.
 */
export const EnrollRoute: React.FC = () => {
    if (isDeviceEnrolled() && isAuthenticated()) {
        return <Navigate replace to={getRoleHomePath(getUser()?.role)} />;
    }
    return <Outlet />;
};
